import React from 'react';
import Icon from '../../../components/AppIcon';

const EventFilters = ({ selectedTypes, onTypeToggle }) => {
  const eventTypes = [
    {
      id: 'leave',
      label: 'Approved Leave',
      icon: 'Calendar',
      color: 'bg-blue-500',
      textColor: 'text-blue-700',
      bgColor: 'bg-blue-100',
      borderColor: 'border-blue-500'
    },
    {
      id: 'events',
      label: 'Company Events',
      icon: 'CalendarCheck',
      color: 'bg-green-500',
      textColor: 'text-green-700',
      bgColor: 'bg-green-100',
      borderColor: 'border-green-500'
    },
    {
      id: 'deadlines',
      label: 'DLIR Deadlines',
      icon: 'AlertCircle',
      color: 'bg-red-500',
      textColor: 'text-red-700',
      bgColor: 'bg-red-100',
      borderColor: 'border-red-500'
    },
    {
      id: 'availability',
      label: 'Team Availability',
      icon: 'Users',
      color: 'bg-amber-500',
      textColor: 'text-amber-700',
      bgColor: 'bg-amber-100',
      borderColor: 'border-amber-500'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <h4 className="font-heading font-semibold text-sm text-foreground mb-3">
        Event Types
      </h4>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {eventTypes?.map((type) => {
          const isSelected = selectedTypes?.includes(type?.id);
          return (
            <button
              key={type?.id}
              onClick={() => onTypeToggle(type?.id)}
              className={`
                flex items-center gap-2 px-3 py-2 rounded-md border-2 transition-smooth
                ${
                  isSelected
                    ? `${type?.bgColor} ${type?.textColor} ${type?.borderColor} shadow-sm`
                    : 'bg-muted text-muted-foreground border-border hover:border-muted-foreground'
                }
              `}
              aria-pressed={isSelected}
            >
              <div className={`w-3 h-3 rounded-full ${isSelected ? type?.color : 'bg-muted-foreground'}`} />
              <Icon
                name={type?.icon}
                size={16}
                color={isSelected ? 'currentColor' : 'var(--color-muted-foreground)'}
              />
              <span className="text-xs font-medium truncate">{type?.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default EventFilters;